/** Return the optional host bridge exposed by the embedding shell. */
export function useLensHost() {
    if (typeof window === "undefined")
        return null;
    return window.lensHost ?? null;
}
//# sourceMappingURL=useLensHost.js.map